import { render, staticRenderFns } from "./leave-authorization.vue?vue&type=template&id=9db683ea&"
import script from "./leave-authorization.vue?vue&type=script&lang=js&"
export * from "./leave-authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports